import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions/customer';

export class ConfirmView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			title: '',
			message: '',
			type: ''
		};
	}

	componentDidMount () {
		this.props.actions.confirmRegister().then(function(response){
			this.setState({
				isLoading: false,
				title: response.title,
				message: response.success ? response.success : response.error,
				type: response.success ? 1 :0
			});
		}.bind(this));
	}

	render () {
		let imgStyle = {
			width: '320px'
		};
		if(this.state.isLoading == false) {
			if(this.state.type)
				return (
				<div id="register-confirm" className="ui middle aligned center aligned grid">
					<div className="column">
						<h2 className="ui teal header">
							<img alt="" style={imgStyle} src={'/static/img/glasstechnika-logo.jpg'} />
							<div className="title">Potwierdzenie rejestracji</div>
						</h2>
						<div className="context green">
							<strong>{this.state.title}</strong><br /><br />
							{this.state.message}
						</div>
					</div>
				</div>);
			else
				return (
				<div id="register-confirm" className="ui middle aligned center aligned grid">
					<div className="column">
						<h2 className="ui teal header">
							<img alt="" style={imgStyle} src={'/static/img/glasstechnika-logo.jpg'} />
							<div className="title">Potwierdzenie rejestracji</div>
						</h2>
						<div className="context red">
							<strong>{this.state.title}</strong><br /><br />
							{this.state.message}
						</div>
					</div>
				</div>);
		}else
			return(<div className="loading-form"></div>);
	}
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({
	actions : bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmView);


/** WEBPACK FOOTER **
 ** ./js/views/ConfirmView.js
 **/